// 每日挑战出题（v2 spec §4）：按日期做种子，从全部主题（三城 + 塔罗）的地点里选一个、固定打乱种子；全天同一题。
// 格数按星期循环（core/levels 的 dailySize）。
import { imageAspect, type Manifest, type Place } from '../content/manifest';
import { dailyGrid, dailyMods, dailySize, type Grid, type LevelMods } from './levels';

/** FNV-1a 32 位：同一字符串在任何设备上得到同一个数 */
function hash(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/** n = 当天按星期的格数；grid = 实际的格（城市 n×n；抽到竖版塔罗牌时换成竖版格，见 levels.dailyGrid） */
export type DailyPuzzle = { date: string; themeId: string; place: Place; n: number; grid: Grid; seed: number; mods: LevelMods };

/** manifests 按城市 order 排好；地点按 unlockOrder（顺序固定，内容不变则题目不变） */
export function dailyPuzzle(date: string, manifests: Manifest[]): DailyPuzzle {
  const all: { themeId: string; place: Place; aspect: number }[] = [];
  for (const m of [...manifests].sort((a, b) => a.theme.order - b.theme.order)) {
    for (const p of [...m.places].sort((a, b) => a.unlockOrder - b.unlockOrder)) all.push({ themeId: m.theme.id, place: p, aspect: imageAspect(m) });
  }
  const pick = all[hash(`daily:${date}`) % all.length];
  const n = dailySize(date);
  return { date, themeId: pick.themeId, place: pick.place, n, grid: dailyGrid(n, pick.aspect), seed: (hash(`shuffle:${date}`) % 2 ** 30) + 1, mods: dailyMods(date) };
}
